<template>
    <v-flex>
        <h1 class="mt-5 mb-4 text-xs-center mx-auto headline">{{msg}}</h1>
        <!-- <v-toolbar flat light class="text-xs-center mx-auto mb-4">
          <v-toolbar-title class="text-xs-center title">{{msg}}</v-toolbar-title>
        </v-toolbar> -->
        <date-select></date-select>
        <self-assess v-if="false"></self-assess>
        <voice-pitch v-if="true"></voice-pitch>
        <voice-feel-home></voice-feel-home>
        <vocal-activity-home></vocal-activity-home>
        <vocal-naps-home></vocal-naps-home>
        <water-consumption-home></water-consumption-home>
    </v-flex>
</template>

<script>
import VoiceFeelHome from './home/VoiceFeelHome.vue'
import VocalActivityHome from './home/VocalActivityHome.vue'
import VocalNapsHome from './home/VocalNapsHome.vue'
import WaterConsumptionHome from './home/WaterConsumptionHome.vue'
import DateSelect from './DateSelect.vue'
import VoicePitch from './home/VoicePitch.vue'
import SelfAssess from './home/SelfAssess.vue'

export default {
  data () {
    return {
      msg: 'Good Morning, '+localStorage.username+'!'
    }
  },
  components: {
            'voice-feel-home': VoiceFeelHome,
            'vocal-activity-home': VocalActivityHome,
            'vocal-naps-home': VocalNapsHome,
            'water-consumption-home': WaterConsumptionHome,
            'date-select': DateSelect,
            'voice-pitch': VoicePitch,
            'self-assess': SelfAssess,
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Home.vue